import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Transition as _Transition, withCtx as _withCtx, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "chat",
  class: "pulse"
}
const _hoisted_2 = { class: "tab" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Tracker = _resolveComponent("Tracker")
  const _component_Feed = _resolveComponent("Feed")
  const _component_HintsInput = _resolveComponent("HintsInput")
  const _component_Rightbar = _resolveComponent("Rightbar")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      ($options.active === 'tracker')
        ? (_openBlock(), _createBlock(_component_Tracker, {
            key: 0,
            ref: "tracker",
            "chosen-id": $options.active_id,
            class: "tab-container",
            onToggleTab: _cache[0] || (_cache[0] = $event => ($options.active = 'feed'))
          }, null, 8 /* PROPS */, ["chosen-id"]))
        : (_openBlock(), _createBlock(_component_Feed, {
            key: 1,
            ref: "feed",
            "vread-from": "show_filters",
            "onUpdate:show_filters": $event => (($data.show_filters) = $event),
            class: "tab-container",
            "chosen-id": $options.active_id,
            onToggleTab: _cache[1] || (_cache[1] = $event => ($options.active = 'tracker')),
            onOpenSignal: $options.openSignal
          }, null, 8 /* PROPS */, ["onUpdate:show_filters", "chosen-id", "onOpenSignal"])),
      _createVNode(_Transition, { name: "hints-fade" }, {
        default: _withCtx(() => [
          _createVNode(_component_HintsInput, { class: "hints-input" })
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _createVNode(_component_Rightbar, {
      ref: "rightbar",
      class: "rightbar",
      data: $data.rb_data,
      view: $data.view,
      onClose: $options.close
    }, null, 8 /* PROPS */, ["data", "view", "onClose"])
  ]))
}